// /src/store/index.js
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";

// ------------------ Reducer Imports ------------------
import uiReducer from "./slices/uiSlice";
import authReducer from "./slices/authSlice";
import messagesReducer from "./slices/messagesSlice";
import ordersReducer from "./slices/ordersSlice";
import notificationsReducer from "./slices/notificationsSlice";

// ------------------ Persist Configuration ------------------
const persistConfig = {
  key: "root",
  storage,
  // List the slices you want to keep in local storage
  whitelist: ["auth", "messages"],
  // blacklist: ['ui', 'orders'], // Optional: slices to exclude
};

// ------------------ Root Reducer ------------------
// Merging the cleaner structure from the second code version
const rootReducer = combineReducers({
  auth: authReducer,
  messages: messagesReducer,
  orders: ordersReducer,
  ui: uiReducer,
  notifications: notificationsReducer, // Included but not persisted
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ------------------ Store Configuration ------------------
export const store = configureStore({
  reducer: persistedReducer, // uses combined persisted reducer
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// ------------------ Persistor Export ------------------
export const persistor = persistStore(store);

// ------------------ Default Export (optional convenience) ------------------
export default store;
